import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans flex flex-col" data-id="element-188">
      <main className="flex-grow py-16 px-4 md:px-8" data-id="element-189">
        <div className="max-w-4xl mx-auto" data-id="element-190">
          <Link to="/" className="inline-flex items-center gap-2 text-gold-primary hover:text-gold-accent transition-colors mb-12 font-medium" data-id="element-191">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-192" />
            Back to Home
          </Link>

          <div className="space-y-12" data-id="element-193">
            <header className="border-b border-gray-800 pb-8" data-id="element-194">
              <h1 className="font-serif text-4xl md:text-5xl mb-4 text-white" data-id="element-195">
                Terms of Service
              </h1>
              <p className="text-gray-400" data-id="element-196">Last updated: April 2026</p>
            </header>

            <section className="space-y-4" data-id="element-197">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-198">
                1. Introduction
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-199">
                Welcome to Cotifunding. By accessing or using our website, you
                agree to be bound by these Terms of Service. If you do not agree
                to these terms, please do not use our website or services.
              </p>
            </section>

            <section className="space-y-4" data-id="element-200">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-201">
                2. Services
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-202">
                Cotifunding provides access to business funding solutions
                through a network of trusted partners. Our services help connect
                businesses with financing options including:
              </p>
              <ul className="list-disc pl-6 text-gray-300 space-y-2" data-id="element-203">
                <li data-id="element-204">Term loans</li>
                <li data-id="element-205">Lines of credit</li>
                <li data-id="element-206">Equipment financing</li>
                <li data-id="element-207">Merchant cash advances</li>
              </ul>
            </section>

            <section className="space-y-4 bg-charcoal p-6 rounded-xl border border-gray-800" data-id="element-208">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-209">
                3. No Guarantee of Approval
              </h2>
              <p className="text-gray-300 leading-relaxed font-medium" data-id="element-210">
                Submission of your information does not guarantee approval or
                funding. All funding decisions are made by our lending partners
                based on their own underwriting criteria and evaluation
                processes.
              </p>
            </section>

            <section className="space-y-4" data-id="element-211">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-212">
                4. Not a Direct Lender
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-213">
                Cotifunding is not a direct lender. We operate as a lead
                generation and referral service that connects users with
                third-party funding providers. Any financing agreement you enter
                into will be directly between you and the respective funding
                partner.
              </p>
            </section>

            <section className="space-y-4" data-id="element-214">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-215">
                5. User Responsibilities
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-216">
                By using our services, you agree to:
              </p>
              <ul className="list-disc pl-6 text-gray-300 space-y-2" data-id="element-217">
                <li data-id="element-218">
                  Provide accurate, truthful, and complete information when
                  submitting any forms on our website
                </li>
                <li data-id="element-219">
                  Not misrepresent your identity, business details, or financial
                  standing
                </li>
                <li data-id="element-220">
                  Use our services only for lawful purposes related to business
                  funding
                </li>
              </ul>
            </section>

            <section className="space-y-4 bg-charcoal p-6 rounded-xl border border-gray-800" data-id="element-221">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-222">
                6. Communications Consent
              </h2>
              <p className="text-gray-300 leading-relaxed font-medium" data-id="element-223">
                By submitting your information, you consent to receive calls,
                emails, and text messages from Cotifunding regarding your
                inquiry. Message and data rates may apply. You may opt out of
                text messages at any time by replying STOP.
              </p>
            </section>

            <section className="space-y-4" data-id="element-224">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-225">
                7. Limitation of Liability
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-226">
                Cotifunding is not responsible for any decisions, actions, or
                outcomes resulting from interactions with our lending partners.
                We do not guarantee the terms, rates, or conditions offered by
                any third-party funding provider. Cotifunding shall not be held
                liable for any direct, indirect, incidental, or consequential
                damages arising from the use of our services.
              </p>
            </section>

            <section className="space-y-4" data-id="element-227">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-228">
                8. Changes to Terms
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-229">
                Cotifunding reserves the right to update or modify these Terms
                of Service at any time without prior notice. Continued use of
                our website following any changes constitutes your acceptance of
                the revised terms. We encourage you to review this page
                periodically.
              </p>
            </section>

            <section className="space-y-4" data-id="element-230">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-231">
                9. Contact Information
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-232">
                If you have any questions about these Terms of Service, please
                contact us at:
              </p>
              <a href="mailto:contact@cotifunding.com" className="text-gold-primary hover:text-gold-accent transition-colors inline-block mt-2" data-id="element-233">
                contact@cotifunding.com
              </a>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-234" />
    </div>;
}